import { generateVariantsWithPrefix, styled, textColors } from 'ui'

const TextStyled = styled('span', {
  defaultVariants: {
    color: 'text1'
  },
  variants: {
    noWrap: {
      true: {
        whiteSpace: 'nowrap'
      }
    },
    truncate: {
      true: {
        truncate: true
      }
    },
    weight: {
      regular: {
        fontWeight: '$regular'
      },
      medium: {
        fontWeight: '$medium'
      },
      semiBold: {
        fontWeight: '$semi-bold'
      },
      bold: {
        fontWeight: '$bold'
      }
    },
    size: {
      '2xs': {
        fontSize: '$2xs',
        lineHeight: '$2xs'
      },
      xs: {
        fontSize: '$xs',
        lineHeight: '$xs'
      },
      sm: {
        fontSize: '$sm',
        lineHeight: '$sm'
      },
      md: {
        fontSize: '$md',
        lineHeight: '$md'
      },
      lg: {
        fontSize: '$lg',
        lineHeight: '$lg'
      },
      xl: {
        fontSize: '$xl',
        lineHeight: '$xl'
      },
      '2xl': {
        fontSize: '$2xl',
        lineHeight: '$2xl'
      },
      '3xl': {
        fontSize: '$3xl',
        lineHeight: '$3xl',
        letterSpacing: '$tight'
      },
      '4xl': {
        fontSize: '$4xl',
        lineHeight: '$4xl',
        letterSpacing: '$tight'
      },
      '5xl': {
        fontSize: '$5xl',
        lineHeight: '$5xl',
        letterSpacing: '$tighter'
      },
      '6xl': {
        fontSize: '$6xl',
        lineHeight: '$6xl',
        letterSpacing: '$tighter'
      }
    },
    color: textColors,
    colorHover: generateVariantsWithPrefix<typeof textColors>(
      textColors,
      '&:hover'
    ),
    transition: {
      true: {
        transition: '.2s ease'
      }
    },
    uppercase: {
      true: {
        textTransform: 'uppercase'
      }
    },
    italic: {
      true: {
        fontStyle: 'italic'
      }
    },
    capitalize: {
      true: {
        textTransform: 'capitalize'
      }
    },
    underline: {
      true: {
        textDecoration: 'underline',
        textUnderlineOffset: 3
      }
    },
    underlineHover: {
      true: {
        '&:hover': {
          textDecoration: 'underline',
          textUnderlineOffset: 3
        }
      }
    },
    align: {
      center: {
        textAlign: 'center'
      },
      left: {
        textAlign: 'left'
      },
      right: {
        textAlign: 'right'
      }
    },
    srOnly: {
      true: {
        position: 'absolute',
        size: 1,
        m: -1,
        p: 0,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        borderWidth: 0
      }
    }
  }
})

export default TextStyled
